import Cookies from 'js-cookie';
import { onGlobalVarSet } from '@mm/utils';
import { PAP_COOKIE, PAP_COOKIE_DOMAIN } from '@mm/constants/referrals';

const cookieExpirationDays = 365;
const cookieOptions: Cookies.CookieAttributes = {
  path: '/',
  expires: cookieExpirationDays,
  secure: true,
  sameSite: 'none',
  httpOnly: false,
  domain: PAP_COOKIE_DOMAIN,
};

export async function init() {
  await onGlobalVarSet<any>('PostAffTracker');

  PostAffTracker.setAccountId('default1');
  const urlParams = new URLSearchParams(window.location.search);
  const affiliateIdParam = AffiliateID || urlParams.get('a_aid');
  const oldTrackingFinished = trackingFinished;
  trackingFinished = (...args: any[]) => {
    oldTrackingFinished(...args);
    // AffiliateID changed outside
    // is expected to be followed by a track() call
    const affiliateId = AffiliateID || affiliateIdParam;
    const visitorId = PostAffTracker.getVisitorId();
    if (visitorId && affiliateId) {
      const value = `${affiliateId}::${visitorId}`;
      try {
        localStorage.setItem(PAP_COOKIE, value);
      } catch {}
      Cookies.set(PAP_COOKIE, value, cookieOptions);
    }
  };
  // already tracked elsewhere
  if (PostAffTracker.getVisitorId()) {
    return;
  }
  try {
    const existingValue =
      Cookies.get(PAP_COOKIE) || localStorage.getItem(PAP_COOKIE);
    if (existingValue) {
      const [_, visitorId] = existingValue.split('::');
      if (visitorId) {
        PostAffTracker.setVisitorId(visitorId);
      }
    }
  } catch {}
  if (affiliateIdParam) {
    try {
      PostAffTracker.track();
    } catch {}
  }
}
